import React, { useMemo } from 'react';
import Shimmer from '../atoms/Loader/Shimmer';
import { Asset } from '@cube3/common/model/schema/resources/asset';
import { Folder } from '@cube3/common/model/schema/resources/folder';
import { AssetTile, useAssetTileCSS } from '../molecules/ReviewTools/AssetTile';
import { Typography } from '../atoms/Typography';

export interface NodeTreeProps {
  parentId: string;
  rootNode: string;
  /** The selected asset */
  activeAsset: Asset;
  renderAssetTile: (asset: Asset) => JSX.Element;
  'data-type'?: string;
  // folder
  onClickFolder: (folder: string) => void;
  getChildren: (id: string) => {
    assets: Asset[];
    folders: Folder[];
  };
  isExpanded: (id: string) => boolean;
}

export const NodeTree = (props: NodeTreeProps) => {
  const {
    parentId,
    activeAsset,
    rootNode,
    renderAssetTile,
    getChildren,
    onClickFolder,
    isExpanded,
    ...restProps
  } = props;
  const classes = useAssetTileCSS();

  const activeFolder = activeAsset?.relationships.parent.id;

  const { folders, assets } = useMemo(
    () => getChildren(parentId),
    [getChildren, parentId]
  );

  if (!folders && !assets) {
    return <Loading />;
  }

  return (
    <>
      {folders && assets && !folders.length && !assets.length && (
        <div style={{ padding: 16 }}>
          <Typography>Empty folder</Typography>
        </div>
      )}
      {folders.length
        ? folders.map((f, idx) => (
            <>
              <AssetTile
                key={f.id + idx}
                {...restProps}
                type={'folder'}
                resource={f}
                onClick={() => onClickFolder(f.id)}
                expanded={isExpanded(f.id)}
              />
              <div
                className={`${classes.withBorderLeft} ${
                  activeFolder === f.id ? 'active' : ''
                }`}
              >
                {isExpanded(f.id) && <NodeTree {...props} parentId={f.id} />}
              </div>
            </>
          ))
        : null}
      {assets.length ? (
        <div
          data-type={parentId === rootNode ? '' : props['data-type']}
          id={parentId}
        >
          {assets.map((a) => renderAssetTile(a))}
        </div>
      ) : null}
    </>
  );
};

const Loading = () => {
  return (
    <div style={{ margin: '4px 16px' }}>
      <Shimmer variant="rectangle" height={64} />
      <div style={{ height: 8 }}></div>
      <Shimmer variant="rectangle" height={64} />
      <div style={{ height: 8 }}></div>
      <Shimmer variant="rectangle" height={64} />
    </div>
  );
};
